<dx-popup [(visible)]="visible"
          [dragEnabled]="false"
          [fullScreen]="fullScreen"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [showTitle]="true"
          [title]="editMode ? ('Lieferant ändern' | translate) : ('Lieferant anlegen' | translate)"
          height="70%"
          width="50%">

  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Abbrechen' | translate), type:'normal', icon:'close', onClick: onCancel }"
    location="after"
    toolbar="bottom"
    widget="dxButton">
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item [options]="{ stylingMode: 'outlined', text: ('Speichern' | translate), type:'default', icon:'save', onClick: onSave }"
                          location="after"
                          toolbar="bottom"
                          widget="dxButton">
  </dxi-popup-toolbar-item>

    <dxi-popup-toolbar-item *ngIf="showChangeWarning && !warningDismissed"
                            [options]="{ stylingMode: 'outlined', text: ('Neuer Lieferant' | translate), type:'normal', onClick: changeEditMode }"
                            location="before"
                            toolbar="bottom"
                            widget="dxButton">
    </dxi-popup-toolbar-item>

    <dxi-popup-toolbar-item [options]="{
                            stylingMode: 'outlined', 
                            icon : fullScreen ? 'collapse' : 'fullscreen',
                            hint: fullScreen ? 'Minimize' : 'Maximize',
                            onClick: toggleFullScreen
                          }"
                          location="after"
                          toolbar="top"
                          widget="dxButton">
  </dxi-popup-toolbar-item>

    <div *dxTemplate="let data of 'content'">

        <div *ngIf="showChangeWarning && !warningDismissed" class="supplier-edit-warning">
            <i class="dx-icon dx-icon-warning"></i>
            <span>{{ 'warningBeforeContainer' | translate }}<a class="supplier-edit-warning-link"
                                        (click)="changeEditMode()">{{ 'warningLinkTextContainer' | translate }}</a>{{ 'warningAfterContainer' | translate }}</span>
        </div>


        <dx-tab-panel
        [animationEnabled]="true"
        [swipeEnabled]="false"
        iconPosition="start"
        stylingMode="primary"
        width="100%">

        <dxi-item [title]="'Unternehmensinformationen' | translate" icon="group">
          <div *dxTemplate>
            <div class="inspect-content p-2">
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Name' | translate }}</div>
                <div class="dx-field-value">
                  <dx-autocomplete [(value)]="dataSource.name"
                                   [dataSource]="supplierNames"
                                   [minSearchLength]="1"
                                   [showClearButton]="true"
                                   searchMode="contains">
                  </dx-autocomplete>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Typ' | translate }}</div>
                <div class="dx-field-value">
                  <dx-lookup [(value)]="dataSource.type" [items]="types"/>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Kreditoren-Nr.' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.kreditorNr" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'GLN' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.gln" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <ng-container *ngIf="loginService.hasAddonBauvista">
                <div class="dx-field">
                  <div class="dx-field-label">{{ 'Bauvista-Lieferant' | translate }}</div>
                  <div class="dx-field-value">
                    <dx-switch [(value)]="dataSource.bauvistaSupplier"
                               switchedOffText="{{ 'Nein' | translate }}"
                               switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
                  </div>
                </div>

                <div class="dx-field">
                  <div class="dx-field-label">{{ 'Bauvista-Namenspraefixe' | translate }}</div>
                  <div class="dx-field-value">
                    <dx-text-box [(value)]="dataSource.bauvistaNamePrefixes"
                                 [showClearButton]="true"
                                 placeholder="Praefix1|Praefix2"></dx-text-box>
                  </div>
                </div>

                <div class="dx-field">
                  <div class="dx-field-label">{{ 'Löschkennzeichen' | translate }}</div>
                  <div class="dx-field-value">
                    <dx-switch [(value)]="dataSource.deletionFlag"
                               switchedOffText="{{ 'Nein' | translate }}"
                               switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
                  </div>
                </div>
              </ng-container>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Alternative Namen' | translate }}</div>
                <div class="dx-field-value">
                  <dx-tag-box (onCustomItemCreating)="addAlternativeName($event)"
                              (onValueChanged)="onAltNamesChanged($event)"
                              [(value)]="selectedAltNames"
                              [acceptCustomValue]="true"
                              [items]="altNameOptions"
                              [searchEnabled]="true"
                              [showSelectionControls]="true"
                              stylingMode="outlined">
                  </dx-tag-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Straße' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.addressObj.street" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'PLZ' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.addressObj.zip" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Stadt' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.addressObj.city" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Country Code' | translate }}</div>
                <div class="dx-field-value">
                  <dx-select-box (valueChange)="onCountryChanged($event)"
                                 [(value)]="dataSource.countryCode"
                                 [dataSource]="countryCodes"
                                 [dropDownOptions]="{ maxHeight: 300 }"
                                 [minSearchLength]="0"
                                 [searchEnabled]="true"
                                 [searchExpr]="['name','code']"
                                 displayExpr="label"
                                 searchMode="contains"
                                 valueExpr="code">
                  </dx-select-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Webseite' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.website" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Beschreibung' | translate }}</div>
                <div class="dx-field-value" style="height: 250px;">
                  <dx-html-editor [(value)]="dataSource.description" class="scroll-editor" height="100%" width="100%">
                    <dxo-toolbar>
                      <dxi-item name="undo"></dxi-item>
                      <dxi-item name="redo"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="bold"></dxi-item>
                      <dxi-item name="italic"></dxi-item>
                      <dxi-item name="underline"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="alignLeft"></dxi-item>
                      <dxi-item name="alignCenter"></dxi-item>
                      <dxi-item name="alignRight"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item [acceptedValues]="[1, 2, 3, 4, 5, false]" name="header"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="orderedList"></dxi-item>
                      <dxi-item name="bulletList"></dxi-item>
                    </dxo-toolbar>
                  </dx-html-editor>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Logo' | translate }}</div>
                <div class="dx-field-value">
                  <dx-file-uploader (onBeforeSend)="onBeforeSendUpload($event)"
                                    (onUploaded)="onUploaded($event)"
                                    [(value)]="value"
                                    [allowedFileExtensions]="['.jpg', '.jpeg', '.png', '.gif', '.svg']"
                                    [multiple]="false"
                                    [uploadCustomData]="{
                              dataSourceId: dataSource.id,
                              customerId: loginService.currentUser.customerId
                            }"
                                    [uploadHeaders]="uploadHeaders"
                                    accept="*"
                                    uploadMode="instantly"
                                    uploadUrl="api/DataSources/UploadLogo">
                  </dx-file-uploader>
                </div>
              </div>


              <div class="dx-field">
                <div class="dx-field-label">{{ 'zugehörige Marken' | translate }}</div>
                <div class="dx-field-value">
                  <dx-list [items]="relatedBrands" class="brand-list">
                    <ng-template dxTemplate="item" let-text>
                      {{ text }}
                    </ng-template>
                  </dx-list>
                </div>
              </div>
            </div>
          </div>
        </dxi-item>

        <dxi-item [title]="'Weitere Infos' | translate" icon="info">
          <div *dxTemplate>
            <div class="inspect-content p-2">
              <div class="dx-card card-compact">
                <div class="dx-fieldset">
                  <div class="dx-fieldset-header">{{ 'Informationen zum Produktsicherheitsgesetz' | translate }}</div>
                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Ansprechpartner' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.contactPerson" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Support Telefon' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.supportTel" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Support E-Mail' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.supportMail" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Link zur Garantie / Produktsicherheit' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.warrantyPages" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Support Website' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.supportWebsite" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>
                </div>
              </div>

              <div class="dx-card card-compact">
                <div class="dx-fieldset">
                  <div class="dx-fieldset-header">{{ 'Zusatzinformationen' | translate }}</div>
                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Ansprechpartner' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.salesContact" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Vertriebswebsite' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.salesSupportWebsite" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'E-Mail des Unternehmens' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.salesMail" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Telefonnummer' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.salesTel" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>
                </div>
              </div>

              <div class="dx-card card-compact" *ngIf="!isEuCountry">
                <div class="dx-fieldset">
                  <div class="dx-fieldset-header">{{ 'Importeur Informationen' | translate }}</div>
                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Name' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.importerName" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Straße' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.importerAddress.street" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'PLZ' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.importerAddress.zip" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Stadt' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.importerAddress.city" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Land' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-select-box [(value)]="dataSource.importerCountryCode"
                                     [dataSource]="countryCodes"
                                     [dropDownOptions]="{ maxHeight: 300 }"
                                     [minSearchLength]="0"
                                     [searchEnabled]="true"
                                     [searchExpr]="['name','code']"
                                     displayExpr="label"
                                     searchMode="contains"
                                     valueExpr="code">
                      </dx-select-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">{{ 'Website' | translate }}</div>
                    <div class="dx-field-value">
                      <dx-text-box [(value)]="dataSource.importerWebsite" [showClearButton]="true"></dx-text-box>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </dxi-item>

        <dxi-item *ngIf="loginService.hasAddonElectronicSales" title="SEO">
          <div *dxTemplate>
            <div class="inspect-tab-pane p-2">
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Meta-Title' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.seoMetaTitle" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">{{ 'Meta-Description' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="dataSource.seoMetaDescription" [showClearButton]="true"></dx-text-box>
                </div>
              </div>
            </div>
          </div>
        </dxi-item>

      </dx-tab-panel>


    </div>
</dx-popup>
